import { render } from "./CompleteUserAccountView.vue?vue&type=template&id=38a1e1cc"
import script from "./CompleteUserAccountView.vue?vue&type=script&lang=js"
export * from "./CompleteUserAccountView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__